var _style, _path, _rect, _rect2, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.35 28.35",
    style: {
      enableBackground: "new 0 0 28.35 28.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:1.5001;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\r\n\t\r\n\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:1.0001;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.74,2.09H19.6c0.79,0,1.43,0.65,1.43,1.43v19.92c0,0.79-0.65,1.43-1.43,1.43H8.74 c-0.79,0-1.43-0.65-1.43-1.43V3.52C7.31,2.73,7.96,2.09,8.74,2.09z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.74,
    y: 24.87,
    className: "st0",
    width: 1.16,
    height: 1.49
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.44,
    y: 24.87,
    className: "st0",
    width: 1.16,
    height: 1.49
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8.74,
    y1: 15.6,
    x2: 8.74,
    y2: 19.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7.31,
    y1: 14.17,
    x2: 21.04,
    y2: 14.17
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8.74,
    y1: 5.11,
    x2: 8.74,
    y2: 8.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridge);
export default __webpack_public_path__ + "static/media/fridge.1f98bb5ec49ed8dd5f55b7a13826f599.svg";
export { ForwardRef as ReactComponent };